import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BotonTipo } from '../../../components/boton/boton';
import { MatDialog } from '@angular/material';
import { EditarUsuarioDialog } from './editar-usuario-dialog/editar-usuario-dialog.component';

@Component({
  selector: 'app-editar-usuario',
  templateUrl: './editar-usuario.component.html',
  styleUrls: ['./editar-usuario.component.scss']
})
export class EditarUsuarioComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() IdUsuario?: number | string;
  @Input() disabled: boolean = false;
  @Input() editable: boolean = false;
  @Input() tooltipDir: string = 'below';
  @Output() onCerrado = new EventEmitter();

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
    if (!this.IdUsuario) {
      throw "La variable Input 'IdUsuario' es requerida";
    }
  }

  openDialog(): void {
    let dialogEditar = this.dialog.open(EditarUsuarioDialog, {
      disableClose: true,
      data: {
        IdUsuario: this.IdUsuario
      }
    });

    dialogEditar.afterClosed().subscribe(() => {
      this.onCerrado.emit();
    });
  }
}
